<template>
  <div>
    <v-alert :type="alertType" v-model="alertActive" dismissible outline>{{
      alertMessage
    }}</v-alert>

    <v-flex xs12 sm6 offset-sm3>
      <v-card max-width="600px">
        <v-form>
          <v-container class="primary" fill-height>
            <v-layout fill-height>
              <v-flex xs12 align-end flexbox>
                <span class="headline white--text">{{
                  $t('reset_password')
                }}</span>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container>
            <v-layout row wrap>
              <v-flex xs12>
                <v-flex xs12>
                  <v-text-field
                    name="Email"
                    prepend-icon="email"
                    :label="$t('email')"
                    @input="$v.email.$touch()"
                    @blur="$v.email.$touch()"
                    :error-messages="emailErrors"
                    v-model="email"
                    required
                    :hint="$t('input_valid_email')"
                  ></v-text-field>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-container>
          <v-card-actions>
            <v-btn flat :to="'/login'">{{ $t('back') }}</v-btn>
            <v-spacer></v-spacer>
            <vue-recaptcha
              ref="invisibleRecaptcha"
              @verify="onVerify"
              @expired="onExpired"
              size="invisible"
              sitekey="6LfBvaoUAAAAAPfeN8nj3-BJ_FJNW2Q2P_Ukbe-X"
              :loadRecaptchaScript="true"
            ></vue-recaptcha>
            <v-btn color="primary" @click="resetPassword">{{
              $t('reset_password')
            }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-flex>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'

import Vue from 'vue'
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'

export default {
  components: {
    VueRecaptcha
  },
  mixins: [validationMixin],

  validations: {
    email: { required, email }
  },
  data() {
    return {
      alertActive: false,
      alertType: 'success',
      alertMessage: '',
      valid: false,
      email: ''
    }
  },
  methods: {
    resetPassword() {
      if (this.invalidForm()) {
        return
      }
      this.onSubmit()
    },
    onSubmit() {
      this.$refs.invisibleRecaptcha.execute()
    },
    async onVerify(response) {
      this.$root.$loader(true)
      try {
        let res = await this.axios.post('/api/captcha/verify/', {
          token: response
        })
        if (res.data.check) {
          try {
            await this.resetPasswordCall()
          } catch (e) {
            console.log(e)
          }
        }
      } catch (error) {
        this.$root.$gerror(error.response.data)
      } finally {
        this.$root.$loader(false)
      }
    },

    onExpired() {
      console.log('Expired')
    },
    resetRecaptcha() {
      this.$refs.invisibleRecaptcha.reset() // Direct call reset method
    },
    async resetPasswordCall() {
      this.$root.$loader(true)
      try {
        await this.axios.get(
          this.$providerURL +
            `/Api/Access/CreatePassword?userName=${this.email}`
        )
        this.showAlert(this.$t('pwd_reset_email_send'), 'success')
      } catch (error) {
        this.$root.$gerror(error.response.data)
      } finally {
        this.$root.$loader(false)
        this.$refs.form.reset()
      }
    },
    showAlert(message, type) {
      this.alertMessage = message
      this.alertType = type
      this.alertActive = true
      setTimeout(() => {
        this.alertActive = false
        this.$router.push('/login')
      }, 10000)
    },
    invalidForm() {
      this.$v.$touch()
      return this.$v.$invalid
    }
  },
  computed: {
    emailErrors() {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      !this.$v.email.required && errors.push(this.$t('email_is_required'))
      !this.$v.email.email && errors.push(this.$t('email_must_be_valid'))
      return errors
    }
  }
}
</script>
